import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { Observable, filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MySpendingInfoViewGuard {
  private _serviceInventory: ServiceInventoryService = inject(ServiceInventoryService);
  private _router: Router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._serviceInventory.getService('my_spending').pipe(
      filter((service) => !!service),
      map((service) => {
        if ([ServiceState.COMPLETE, ServiceState.PENDING, ServiceState.INITIAL].includes(service.state)) {
          return true;
        }
        this._router.navigate(['home']);
        return false;
      })
    );
  }
}
